import { getCdnUrl } from 'owa-config/lib/bootstrapOptions';

const fonts: {
    [key: string]: {
        weight: string;
        locals: string[];
        family: string;
        onlyLocal?: boolean;
    };
} = {
    'segoeui-light': {
        weight: '100',
        locals: ['Segoe UI Light', 'Segoe WP Light'],
        family: 'Segoe UI WestEuropean',
    },
    'segoeui-semilight': {
        weight: '200',
        locals: ['Segoe UI Semilight', 'Segoe WP Semilight'],
        family: 'Segoe UI WestEuropean',
    },
    'segoeui-regular': {
        weight: '400',
        locals: ['Segoe UI', 'Segoe WP'],
        family: 'Segoe UI WestEuropean',
    },
    'segoeui-semibold': {
        weight: '600',
        locals: ['Segoe UI Semibold', 'Segoe WP Semibold'],
        family: 'Segoe UI WestEuropean',
    },
    'segoeui-variable': {
        weight: '100 900',
        locals: ['Segoe UI Variable Text'],
        family: 'Segoe UI Variable Text',
        onlyLocal: true,
    },
};

export function preloadFonts(): Promise<PromiseSettledResult<FontFace>[]> {
    return Promise.allSettled(
        Object.entries(fonts).map(
            ([woffName, info]: [
                string,
                {
                    weight: string;
                    locals: string[];
                    family: string;
                    onlyLocal?: boolean;
                }
            ]) => {
                const localRefs = info.locals.map(local => `local("${local}"), `).join('');
                const font = new FontFace(
                    info.family,
                    info.onlyLocal
                        ? localRefs
                        : `${localRefs}url(${getCdnUrl()}assets/mail/fonts/v1/fonts/${woffName}.woff)`,
                    { weight: info.weight, style: 'normal' }
                );

                // typescript does not have the definition for add method
                (document.fonts as any).add(font);

                // Load the font
                return font.load();
            }
        )
    );
}
